import { Button, Text } from '@elladx/design-system';
import Modal from './Modal';

interface ConfirmDiscardPreparedProps {
    isOpen: boolean;
    title: string;
    confirmLabel: string;
    disabled?: boolean;
    onCancel: () => void;
    onConfirm: () => void;
}

/** Keep the recovery handle until the operator explicitly confirms its removal. */
function ConfirmDiscardPrepared({ isOpen, title, confirmLabel, disabled = false, onCancel, onConfirm }: ConfirmDiscardPreparedProps) {
    return (<Modal isOpen={isOpen} onClose={onCancel} title={title} dismissible={!disabled}>
      <Text className="intro-box warning">
        Check earlier purchases before creating replacement labels. Discarding can allow a duplicate purchase.
      </Text>
      <div className="dialog-actions">
        <Button type="button" variant="secondary" disabled={disabled} onClick={onCancel}>Cancel</Button>
        <Button type="button" variant="danger" disabled={disabled} onClick={onConfirm}>{confirmLabel}</Button>
      </div>
    </Modal>);
}

export default ConfirmDiscardPrepared;
